import React from "react";
import styled from "styled-components";
import MakesOur from "pages/Home/MakesOur";
import "./style.scss"

const IncubatorPage = () => {
    return (
        <>
            <Wrapper>
                <Fullwidth>
                    <Container>
                        <div className="wrap-incubaror">
                            <div className="title-page">
                                BSCS <span>Incubator</span>
                            </div>
                            <div className="desc-page">
                                An intensive accelerator program that empowers crypto startups to shape Web3 through combined expertise in AI, blockchain, and DeFi, with a focus on collaboration, L1 & L2 solutions, and Web3 engagement.
                            </div>
                            <div className="row-incubator">
                                <div className="title">
                                    What are we looking for?
                                </div>
                                <div className="wrap-colum">
                                    <div className="columns">
                                        <div className="colum w-4">
                                            <div className="guide-wrap">
                                                <div className="box-img">
                                                    <img src="./images/new/l-1.svg" alt="" />
                                                </div>
                                                <div className="text">
                                                    AI-Enhanced Web3 Products
                                                </div>
                                                <div className="desc">
                                                    Projects that fuse AI and blockchain to unlock new user experiences, automate DeFi operations, or enhance scalability, security, and decision-making.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="colum w-4">
                                            <div className="guide-wrap">
                                                <div className="box-img">
                                                    <img src="./images/new/l-2.svg" alt="" />
                                                </div>
                                                <div className="text">
                                                    L1 & L2 Infrastructure Builders
                                                </div>
                                                <div className="desc">
                                                    Innovators working on Layer 1 and Layer 2 solutions that improve performance, interoperability, and reduce costs in decentralized ecosystems.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="colum w-4">
                                            <div className="guide-wrap">
                                                <div className="box-img">
                                                    <img src="./images/new/l-3.svg" alt="" />
                                                </div>
                                                <div className="text">
                                                    Next-Gen DeFi & IPFi Protocols
                                                </div>
                                                <div className="desc">
                                                    Startups exploring DeFi, IP tokenization, real-world asset (RWA) trading, or other cutting-edge financial primitives that reshape user ownership and liquidity.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="colum w-6">
                                            <div className="guide-wrap">
                                                <div className="box-img">
                                                    <img src="./images/new/l-4.svg" alt="" />
                                                </div>
                                                <div className="text">
                                                    Strong Teams with Big Vision
                                                </div>
                                                <div className="desc">
                                                    Founders who bring clarity, grit, and execution, backed by strong technical knowledge, a compelling roadmap, and a product-driven mindset.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="colum w-6">
                                            <div className="guide-wrap">
                                                <div className="box-img">
                                                    <img src="./images/new/l-5.svg" alt="" />
                                                </div>
                                                <div className="text">
                                                    Web3 Growth, Gamification & SocialFi
                                                </div>
                                                <div className="desc">
                                                    Platforms that embrace community-powered engagement, reward mechanisms (like XConnect), and SocialFi layers that drive user stickiness and viral growth.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row-incubator">
                                <div className="title">
                                    What BSCS offers?
                                </div>
                                <div className="wrap-colum">
                                    <div className="columns">
                                        <div className="colum w-3">
                                            <div className="guide-wrap">
                                                <div className="box-img">
                                                    <img src="./images/incu-1.png" alt="" />
                                                </div>
                                                <div className="text">
                                                    Project Validation & Advisory
                                                </div>
                                                <div className="desc">
                                                    Rigorous project evaluation and strategic advisory services from industry experts
                                                </div>
                                            </div>
                                        </div>
                                        <div className="colum w-3">
                                            <div className="guide-wrap">
                                                <div className="box-img">
                                                    <img src="./images/incu-2.png" alt="" />
                                                </div>
                                                <div className="text">
                                                    Fundraising & Tokenomics
                                                </div>
                                                <div className="desc">
                                                    Guidance on developing tokenomics and navigating token-based fundraising through public sales, launchpads, and exchanges
                                                </div>
                                            </div>
                                        </div>
                                        <div className="colum w-3">
                                            <div className="guide-wrap">
                                                <div className="box-img">
                                                    <img src="./images/incu-3.png" alt="" />
                                                </div>
                                                <div className="text">
                                                    Community Building & Marketing
                                                </div>
                                                <div className="desc">
                                                    Strategic growth campaigns and narrative-driven branding to build loyal communities and elevate project visibility across Web3
                                                </div>
                                            </div>
                                        </div>
                                        <div className="colum w-3">
                                            <div className="guide-wrap">
                                                <div className="box-img">
                                                    <img src="./images/incu-4.png" alt="" />
                                                </div>
                                                <div className="text">
                                                    Investor & Partner Connections
                                                </div>
                                                <div className="desc">
                                                    Facilitating connections with crypto investors, VC firms, and essential partners for development, legal, and marketing needs
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <MakesOur />
                        </div>
                    </Container>
                </Fullwidth>
            </Wrapper>
        </>
    )
}
export default IncubatorPage

const Wrapper = styled.div`
    padding-top: 92px;
    background-repeat: no-repeat;
    background-position: top;
    background-size: contain;

    @media (max-width: 768px) {
        padding-top: 80px;
    }
`;
const Fullwidth = styled.div`
    width: 100%;
`;
const Container = styled.div`
    width: 1160px;
    padding: 0 10px;
    margin: 0 auto;

    @media (max-width: 768px) {
        width: 100%;
    }
`;